import { Box, Dimensions } from '@factorialco/deprecated-design-system'

/** Renders a layout with a fixed header, a fixed footer and a main content area that uses the rest of the space */

type BoxDimensions = Dimensions | null | undefined
export const Layout = ({
  children,
  header,
  footer,
  ...props
}: {
  children?: React.ReactNode
  header?: React.ReactNode
  footer?: React.ReactNode
  padding?: BoxDimensions
  paddingX?: BoxDimensions
  paddingY?: BoxDimensions
  paddingTop?: BoxDimensions
  paddingBottom?: BoxDimensions
  paddingLeft?: BoxDimensions
  paddingRight?: BoxDimensions
}) => {
  return (
    <Box
      flexDirection="column"
      height="full"
      maxHeight="full"
      className="flex flex-1 flex-col h-full[&>*]:flex-1"
      {...props}
    >
      {header && (
        <Box paddingLeft="s16" paddingRight="s16">
          {header}
        </Box>
      )}
      <Box flexGrow minHeight="s400" paddingTop={header ? 's16' : 's0'}>
        {children}
      </Box>
      {footer && <Box paddingX="s16">{footer}</Box>}
    </Box>
  )
}
